import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import 'normalize.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
// import * as Sentry from '@sentry/react';
// import { Integrations } from '@sentry/tracing';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// if (process.env.NODE_ENV !== 'development') {
//   // TODO: 增加版本标识、上传sourcemap
//   Sentry.init({
//     dsn: 'https://667d0b78ec8a4839bdcfbc1387cdb7f0@sentry.d.xiaomi.net/399',
//     integrations: [new Integrations.BrowserTracing()],
//     environment: process.env.REACT_APP_ENV,
//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
//   });
// }
// if (!['preview', 'production'].includes(process.env.REACT_APP_ENV as string)) {
//   console.log('process.env:', process.env);
// }
